module.exports = __webpack_public_path__ + "static/media/reserve.a8be35d4.svg";